/**
 *
 * @module submitOrderWithPaymentMethodError
*
 */

import Check from 'check-types';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    number,
    string
} = Check.assert;

/**
 *
 * @class SubmitOrderWithPaymentMethodError
 *
 */
export default class SubmitOrderWithPaymentMethodError {

    /**
     *
     * @param {Number} code
     * @param {String} message
     * @param {String} source
     * @throws {InvalidArgumentException}
     *
     */
    constructor(code, message, source) {

        const errorMessage = {
            ctor: 'SubmitOrderWithPaymentMethodError(code, message, source)',
            get submitOrderWithPaymentMethodError() {
                return `${this.ctor} needs submitOrderWithPaymentMethodError Array`;
            },
            get code() {
                return `${this.ctor} code should be a Number`;
            },
            get message() {
                return `${this.ctor} message should be a String`;
            },
            get source() {
                return `${this.ctor} source should be a String`;
            }
        };

        number(code, errorMessage.code, InvalidArgumentException);
        string(message, errorMessage.message, InvalidArgumentException);
        string(source, errorMessage.source, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.code = code;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.message = message;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.source = source;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/submitOrderWithPaymentMethodError.js